import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './CoverTag.module.scss';

interface CoverTagProps {
    className?: string;
}

export const CoverTag: FunctionComponent<CoverTagProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <span className={styles.text}>Cover</span>
        </div>
    );
};

export default CoverTag;
